/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const holidaySchemeCreateRequestSchema = z.object({
  default: z.boolean(),
  description: z.string().min(0).max(1000).nullish(),
  locationIds: z.array(z.int()).nullish(),
  name: z.string().min(0).max(255),
});
